import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { CheckCircle2 } from 'lucide-react';
import SEO from '../components/SEO';

export default function Confirmation() {
    const { ref } = useParams();
    return (
        <div className="max-w-[800px] mx-auto px-4 py-24 text-center" data-testid="purchase-request-confirmation">
            <SEO title="Request Received" noIndex />
            <div className="luxury-card p-12">
                <CheckCircle2 className="w-12 h-12 mx-auto mb-4" style={{ color: 'var(--brand-burgundy)' }} />
                <p className="eyebrow" style={{ color: 'var(--brand-burgundy)' }}>Request Received</p>
                <h1 className="font-serif text-4xl md:text-5xl mt-3" style={{ color: 'var(--brand-burgundy)' }}>Thank you.</h1>
                <hr className="divider-burgundy mt-5 mx-auto" />
                <p className="mt-6 text-base" style={{ color: 'var(--ink-muted)' }}>
                    Our atelier will review your request and reach out within 24 hours to confirm availability, total and arrange delivery.
                </p>
                <p className="mt-5 eyebrow" style={{ color: 'var(--ink-muted)' }}>Reference</p>
                <p className="font-serif text-xl mt-1" data-testid="confirmation-reference" style={{ color: 'var(--ink)' }}>{ref}</p>
                <Link to="/shop" className="mt-8 inline-block btn-outline-burgundy px-6 py-3 rounded-xl text-xs tracking-[0.20em] uppercase">
                    Continue Browsing
                </Link>
            </div>
        </div>
    );
}
